<template>
  <div class="tw-border tw-border-[#EFF0F1] tw-border-solid tw-rounded-[6px]">
    <div
      v-if="isDataLoading"
      class="custom-global-skeleton tw-w-full tw-h-[62px]"
    ></div>
    <div
      v-else
      :id="`vendor-assessment-history-${checklistRequestedId}`"
      :class="`tw-cursor-pointer tw-select-none tw-pr-[25px] tw-bg-[#FCFCFD] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-0  tw-border-solid tw-border-[#EFF0F1]
          ${
            showIcon
              ? 'tw-rounded-[6px]'
              : 'tw-rounded-t-[6px] tw-border-b-[1px]'
          }`"
      :data-cy="`vendor-assessment-history-${checklistRequestedId}`"
      @click="collapseCategory"
    >
      <div
        class="tw-flex tw-flex-row tw-justify-start tw-items-center tw-h-[59px]"
      >
        <div
          class="tw-px-[25px] tw-py-[20px] tw-font-Poppins tw-text-[15px] tw-font-[600] tw-text-[#211F58]"
        >
          {{
            getComponentUiText(
              "app-component-assessment-existing-assessment-dropdown-subtitle-assessment-history-1",
            )
          }}
          <span
            :id="`vendor-assessment-history-total-${checklistRequestedId}`"
            class="tw-font-[400]"
            >({{ totalHistory }})</span
          >
        </div>
      </div>
      <div>
        <span class="float-right button-arrow dropdown-button-arrow-img">
          <img
            v-if="showIcon"
            class="dropdown-button-arrow-img"
            src="@/assets/img/arrow_down2.svg"
          />
          <img
            v-else
            class="collap-button-arrow-down-img"
            src="@/assets/img/arrow_down2.svg"
          />
        </span>
      </div>
    </div>

    <div v-show="!showIcon">
      <div
        v-if="isChecklistAssessmentHistoryLoading"
        class="custom-global-skeleton tw-w-full tw-h-[62px]"
      ></div>
      <div
        v-for="(item, index) in checklistAssessmentHistory as any"
        :key="index"
        class="tw-flex tw-justify-between tw-items-center tw-px-[25px] tw-py-[20px] tw-self-stretch tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-[#EFF0F1] tw-flex-wrap"
      >
        <div class="tw-flex tw-gap-[10px] tw-items-center tw-flex-wrap">
          <div>
            <input
              v-if="updateAssessmentNameId === item.checklistRequestedId"
              :id="`vendor-assessment-history-input-rename-${item.checklistRequestedId}`"
              :value="item.name"
              type="text"
              class="tw-rounded-md tw-w-[150px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-py-[5px] tw-px-[10px] tw-text-[15px] tw-font-[400] tw-text-[#211F58] tw-mr-2"
              @keyup.enter="(e) => onRenameAssessment(e, index)"
              @blur="(e) => onRenameAssessment(e, index)"
            />
            <span
              v-else
              :id="`vendor-assessment-history-name-${item.checklistRequestedId}`"
              :data-cy="`vendor-assessment-history-name-${item.checklistRequestedId}`"
              :class="`${
                item.isArchived ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
              } tw-text-[13px] tw-font-medium tw-font-[Poppins]`"
              >{{ item.name }}</span
            >
            <span
              v-if="item.dateAdded"
              :id="`vendor-assessment-history-dateAdded-${item.checklistRequestedId}`"
              class="tw-text-[13px] tw-text-[#878787]"
            >
              -
              {{ convertUTCTimeToLocalTime(item.dateAdded) }}</span
            >
          </div>
          <div
            v-show="index === 0"
            class="tw-text-[#878787] tw-border tw-border-solid tw-border-[#EFF0F1] tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded-[4px]"
          >
            {{
              getComponentUiText(
                "app-component-assessment-history-label-state-1",
              )
            }}
          </div>
        </div>
        <div class="tw-flex tw-gap-[15px] tw-items-center">
          <div
            v-if="!item.isArchived"
            class="tw-flex tw-gap-[15px] tw-items-center"
          >
            <div
              v-if="item.status !== checklistStatusId.defunct"
              class="tw-text-[#878787] tw-text-[13px] tw-font-[400]"
            >
              {{ getScoreByChecklistId(item.checklistId) }}%
            </div>
            <div
              :class="statusAssessment[item.statusId]?.className"
              class="tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded-[4px]"
              :data-cy="`vendor-assessment-history-status-${item.checklistRequestedId}`"
            >
              <span>{{ statusAssessment[item.statusId]?.label }}</span>
            </div>
          </div>
          <div
            v-else
            class="tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded-[4px] tw-border-solid tw-border-[1px] tw-border-[#FEE5E2] tw-text-[#F7553C]"
            :data-cy="`vendor-assessment-history-status-${item.checklistRequestedId}`"
          >
            <span>{{
              getComponentUiText(
                "app-component-assessments-checklists-requested-status-deleted-1",
              )
            }}</span>
          </div>
          <popoverAssessment
            ref="popoverAssessmentRef"
            style-button="!tw-py-[8px] !tw-px-[8px] tw-ml-[-8px] tw-mr-[-8px] tw-items-center tw-justify-center"
            :offset="20"
            :id-popover="
              'popover-assessment-vendor-history-' + item.checklistRequestedId
            "
            :data-cy-id="
              'popover-assessment-vendor-history-' + item.checklistRequestedId
            "
            :b-popover="`popover-has-tag`"
          >
            <CustomDropDownItem
              v-for="option in subMenuOptions"
              :id="`verdor-assessment-popover-item-${option.id}-${item.checklistRequestedId}`"
              :key="`option_vendor_assessment_history_${option.id}`"
              :is-show-option="option.isShow(item)"
              :id-text="`${option.text(item)}`"
              :data-cy-id="option.dataCy(item)"
              :custom-text-class="`tw-flex tw-items-center tw-gap-[5px] tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                option.arrowRed ? 'tw-text-[#F7553C]' : ''
              } tw-whitespace-normal`"
              :arrow-icon-style="`${
                option.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
              } tw-min-w-[7px]`"
              :padding="'tw-px-[13px] tw-py-[12px]'"
              :custom-class="'tw-flex tw-justify-between tw-items-center !tw-border-0'"
              :tag-status="option.statusTag"
              :tag-status-id="option.statusTagId"
              @click="option.action(item)"
            />
          </popoverAssessment>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Ref, computed, onMounted, ref } from "vue";
import {
  checklistRequestedStatusId,
  CHECKLISTSTATUS,
  checklistStatusId,
} from "@/utils/constants";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { downloadCSV, getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import { useRouter } from "vue-router";
import popoverAssessment from "../assessment/popoverAssessment.vue";
import { IChecklistRequested } from "@/interfaces/vendor";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Checklist, Vendor } from "@/services/apiRoutes/routes";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { putChecklistRequested } from "@/services/vendor";
import { getAssessmentItemsCSV } from "@/services/assessment";
import dayjs from "dayjs";
import CustomDropDownItem from "../common/customDropDownItem.vue";

const isCallApiUpdate = ref(false);

const router = useRouter();

const props = defineProps({
  assessments: {
    type: Array as () => IChecklistRequested[],
    default: () => [],
  },
  assessmentName: { type: String, default: "" },
  checklistId: { type: Number, default: 0 },
  checklistRequestedId: { type: Number, default: 0 },
});
const emit = defineEmits([
  "onRefresh",
  "onChangeRecipient",
  "onSetInprogress",
  "onDeleteAssessment",
]);

const statusAssessment = {};

statusAssessment[checklistRequestedStatusId.inProgress] = {
  className: "checkListRequestedInprogress",
  label: getComponentUiText(
    "app-component-assessments-checklist-requested-status-inprogress-1",
  ),
};
statusAssessment[checklistRequestedStatusId.created] = {
  className: "checkListRequestedCreated",
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-created-1",
  ),
};
statusAssessment[checklistRequestedStatusId.completed] = {
  className: "checkListRequestedCompleted",
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-completed-1",
  ),
};
statusAssessment[checklistRequestedStatusId.waiting] = {
  className: "checkListRequestedWait",
  label: getComponentUiText(
    "app-component-assessments-checklist-requested-status-waiting-1",
  ),
};
statusAssessment[checklistRequestedStatusId.submitted] = {
  className: "checkListRequestedSubmited",
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-submitted-1",
  ),
};
const popoverAssessmentRef: Ref = ref(false);

interface Option {
  id: number;
  arrowRed: boolean;
  statusTag: string;
  statusTagId: string;
  dataCy: (item: any) => string;
  text: (item: any) => string;
  isShow: (item: any) => boolean;
  action: (item: any) => void;
}
const subMenuOptions: Ref<Option[]> = ref([
  {
    id: 1,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: (item) =>
      `vendor-assessment-history-submenu-restore-assessment-${item.checklistRequestedId}`,
    text: () =>
      "app-vendor-assessment-manage-submenu-restore-assessment-option-1",
    isShow: (item) => item.isArchived === true,
    action: (item) => handleRestoreAssessment(item.checklistRequestedId),
  },
  {
    id: 2,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: (item) =>
      `vendor-assessment-history-submenu-view-assessment-${item.checklistRequestedId}`,
    text: (item) =>
      item.statusId === checklistStatusId.completed ||
      item.statusId === checklistStatusId.created
        ? "app-component-assessment-detail-dropdown-option-view-assessment-title-1"
        : "app-component-assessment-detail-review-button",
    isShow: (item) => item.isArchived === false,
    action: (item) => viewAssessment(item.checklistRequestedId),
  },
  {
    id: 3,
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.SUBMITTED,
    statusTagId: CHECKLISTSTATUS.SUBMIT,
    dataCy: () => "",
    text: () => "app-component-dropdown-set-assessment-to-1",
    isShow: (item) =>
      item.isArchived === false &&
      item.statusId === checklistStatusId.completed,
    action: (item) => handleReadyToReviewAssessment(item.checklistRequestedId),
  },
  {
    id: 4,
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.COMPLETED,
    statusTagId: CHECKLISTSTATUS.DONE,
    dataCy: () => "",
    text: () => "app-component-dropdown-set-assessment-to-1",
    isShow: (item) =>
      item.isArchived === false &&
      item.statusId !== checklistStatusId.completed,
    action: (item) => handleCompleteAssessment(item.checklistRequestedId),
  },
  {
    id: 5,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: () => "",
    text: () =>
      "app-vendor-assessment-manage-submenu-rename-assessment-option-1",
    isShow: (item) => item.isArchived === false,
    action: (item) => handleRenameAssessment(item),
  },
  {
    id: 6,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: () => "",
    text: () =>
      "app-vendor-assessment-manage-submenu-change-recipient-option-1",
    isShow: (item) => item.isArchived === false,
    action: (item) => {
      emit("onChangeRecipient", item);
    },
  },
  // {
  //   id: 7,
  //   text: "app-vendor-assessment-manage-submenu-set-inprogress-option-1",
  //   isShow: (item) => item.isArchived === false && item.statusId !== CHECKLISTSTATUS.INPROG,
  //   action: (item) => {
  //     popoverAssessmentRef.value.popoverShow = false;
  //     emit("onSetInprogress", item);
  //   },
  // },
  {
    id: 8,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: () => "",
    text: () =>
      "app-vendor-assessment-manage-submenu-download-assessment-option-1",
    isShow: (item) => item.isArchived === false,
    action: (item) => handleDownloadAssessment(item),
  },
  {
    id: 9,
    arrowRed: true,
    statusTag: "",
    statusTagId: "",
    dataCy: (item) =>
      `vendor-assessment-history-submenu-delete-assessment-${item.checklistRequestedId}`,
    text: () => "app-vendor-assessment-btn-delete-assessment-1",
    isShow: (item) => item.isArchived === false,
    action: (item) => handleDeleteAssessment(item.checklistRequestedId),
  },
]);

const showIcon: Ref<boolean> = ref(true);
const totalHistory = computed(() => checklistAssessmentHistory.value.length);
const isDataLoading: Ref<boolean> = ref(true);
const updateAssessmentNameId: Ref<number> = ref(0);

const checklistAssessmentHistory = computed(() => {
  return props.assessments;
});
const isChecklistAssessmentHistoryLoading: Ref<boolean> = computed(() => {
  return Object.keys(checklistAssessmentHistory).length === 0;
});

onMounted(() => {
  isDataLoading.value = false;
});

const getScoreByChecklistId = (checklistId) => {
  const scorePcnt = checklistAssessmentHistory.value.find(
    (item) => item.checklistRequestedId === checklistId,
  )?.scorePcnt;
  return parseFloat((scorePcnt ?? 0).toFixed(1));
};

const handleDeleteAssessment = async (checklistRequestedId) => {
  try {
    const res = await store.dispatch("Vendor/updateChecklistRequested", {
      params: {
        checklistRequestedIsArchived: true,
      },
      checklistRequestedId,
    });
    if (res) {
      emit("onDeleteAssessment");
      showSuccessToast(
        getComponentUiText("app-vendor-assessment-delete-assessment-success-1"),
      );
    }
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};
const handleRenameAssessment = async (item) => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  updateAssessmentNameId.value = item.checklistRequestedId;
  const idName = `vendor-assessment-history-input-rename-${item.checklistRequestedId}`;
  setTimeout(() => {
    document.getElementById(idName)?.focus();
  }, 300);
};

const onRenameAssessment = async (e, index) => {
  updateAssessmentNameId.value = 0;
  if (!e.target.value) return;
  if (isCallApiUpdate.value) return;

  isCallApiUpdate.value = true;
  store.dispatch("Vendor/updateChecklistRequested", {
    checklistRequestedId:
      checklistAssessmentHistory.value[index]["checklistRequestedId"],
    params: {
      checklistRequestedName: e.target.value,
    },
  });
  setTimeout(() => {
    isCallApiUpdate.value = false;
  }, 100);
};

const collapseCategory = () => (showIcon.value = !showIcon.value);

const viewAssessment = (checklistRequestedId) => {
  router.push({
    name: "AssessmentVendorReview",
    params: { assessmentId: checklistRequestedId },
  });
};

const handleDownloadAssessment = async (item: IChecklistRequested) => {
  try {
    const res = await getAssessmentItemsCSV(item.checklistRequestedId);
    downloadCSV(
      res,
      `CyberSystem_Assessment_Export_${dayjs().format("YYYYMMDD_HHmmss")}_${
        item.name
      }.csv`,
    );
    if (res) {
      showSuccessToast(
        getComponentUiText(
          "app-vendor-assessment-download-assessment-success-1",
        ),
      );
    }
    popoverAssessmentRef.value.popoverShow = false;
  } catch (error) {
    showErrorAPI(error, Checklist.getAssessmentItemsCSV);
  }
};

const handleRestoreAssessment = async (checklistRequestedId) => {
  try {
    popoverAssessmentRef.value.popoverShow = false;

    const res = await store.dispatch("Vendor/updateChecklistRequested", {
      params: {
        checklistRequestedIsArchived: false,
      },
      checklistRequestedId,
    });

    if (!res) return;

    showSuccessToast(
      getComponentUiText("app-vendor-assessment-restore-assessment-success-1"),
    );
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};

const handleCompleteAssessment = async (checklistRequestedId) => {
  const body = { checklistRequestedStatusId: CHECKLISTSTATUS.DONE };
  const params = {
    checklistRequestedId,
  };

  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
      isNoneLoading: true,
      onlyUpdateStatus: true,
    });

    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-complete-success-1",
      ),
    );

    await store.dispatch("Vendor/fetchRequestedChecklist", {
      isArchived: false,
    });
  } catch (error: any) {
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  }
};

const handleReadyToReviewAssessment = async (checklistRequestedId) => {
  const body = { checklistRequestedStatusId: CHECKLISTSTATUS.SUBMIT };
  const params = {
    checklistRequestedId,
  };

  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
      isNoneLoading: true,
      onlyUpdateStatus: true,
    });

    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-ready-review-success-1",
      ),
    );

    await store.dispatch("Vendor/fetchRequestedChecklist", {
      isArchived: false,
    });
  } catch (error: any) {
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  }
};
</script>

<style lang="scss" scoped>
.title__settings {
  font-family: Poppins;
  line-height: 100%; /* 12px */
  letter-spacing: 1.2px;
  text-transform: uppercase;
}
.collap-button-arrow-down-img {
  transform: rotate(-180deg);
}

.inProgress {
  background: #fff;
  border: 1px solid var(--ui-blue-soft, #cfe7ff);
  color: #387dff;
}

.defunct {
  background: #fff;
  border: 1px solid var(--ui-orange-soft, #fee5e2);
  color: #f7553c;
}

.complete {
  background: #fff;
  border: 1px solid var(--ui-green-soft, #d9ede2);
  color: #01893d;
}

.audited {
  background: #fff;
  border: 1px solid #eee4f9;
  color: #904bd6;
}

.onHold {
  background: #fff;
  border: 1px solid #fff0da;
  color: #fe9a05;
}

.notStarted {
  background: #fff;
  border: 1px solid #fee5e2;
  color: #f7553c;
}
.vendorSubmitted {
  background: #fff;
  border: 1px solid #eee4f9;
  color: #904bd6;
}
.waitingForVendor {
  background: #fff;
  border: 1px solid var(--ui-blue-soft, #cfe7ff);
  color: #387dff;
}
.wait {
  background: #fff;
  border: 1px solid var(--ui-blue-soft, #cfe7ff);
  color: #387dff;
}
.submitted {
  background: #fff;
  border: 1px solid #eee4f9;
  color: #904bd6;
}
</style>
